export const redirectToLogin = (appInstanceId: string): void => {
  const loginUrl = new URL(`/hubrise_oauth/login?app_instance_id=${appInstanceId}`, window.location.origin)
  redirectTo(loginUrl.toString())
}

export const redirectTo = (url: string): void => {
  window.location.href = url
}

/**
 * Trigger the callback when the scroll has completed, by checking the scroll position at regular intervals.
 * @param element: The element that scrolls
 * @param scrollTo: The position to scroll to
 * @param needScroll: If false, the callback is triggered immediately
 * @param callback: The callback to trigger
 * @returns The interval to clear when the element is destroyed, or undefined if the callback is triggered immediately
 * or does not need to be triggered.
 */
export const detectScrollCompleted = (
  element: HTMLElement,
  scrollTo: number,
  needScroll: boolean,
  callback?: () => void,
): NodeJS.Timer | undefined => {
  if (!callback) {
    return
  } else if (!needScroll) {
    callback()
    return
  }

  let lastScrollTop = element.scrollTop
  let nbTimesSameScrollTop = 0

  const INTERVAL = 50
  const MAX_TIMES_SAME_SCROLL_TOP = 5

  const interval = setInterval(() => {
    if (
      Math.abs(element.scrollTop - scrollTo) <= 1 ||
      // If the scroll position is not changing anymore, we consider the scroll completed. This can happen
      // if scrollTo is < 0 or > scrollMax.
      (element.scrollTop === lastScrollTop && ++nbTimesSameScrollTop > MAX_TIMES_SAME_SCROLL_TOP)
    ) {
      clearInterval(interval)
      callback()
    }
    lastScrollTop = element.scrollTop
  }, INTERVAL)

  return interval
}

export const appInstanceIdFromUrl = (): string | null => {
  const appInstanceId = new URLSearchParams(window.location.search).get("app_instance_id")
  return appInstanceId === "" ? null : appInstanceId
}
